import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
} from '@angular/core';
import { SearchSection } from '@core/cms/types/cms-footer.response.type';
import { FareSaleHero, FareSaleHeroImage } from '@models/fare-sale.models';
import { booleanStringCheck } from '@shared/ui/utils/global-utils/boolean-string-check';
import { BreadcrumbsItem } from 'jb-component-library';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'jb-hero-container',
  templateUrl: './hero-container.component.html',
  styleUrls: ['./hero-container.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class HeroContainerComponent {
  heroSearch: SearchSection;
  breadcrumbs: BreadcrumbsItem;
  heroData: FareSaleHero;
  heroImage?: FareSaleHeroImage;
}
export const heroContainerResolver = (registry, data) => {
  const heroSearch =
    registry['search'] !== undefined
      ? registry['search'].search
        ? registry['search'].search[0]
        : registry['search']
      : null;

  let breadcrumbs =
    registry['breadcrumbs'] !== undefined
      ? registry['breadcrumbs'].breadcrumbs
        ? registry['breadcrumbs'].breadcrumbs[0]
        : registry['breadcrumbs']
      : null;

  const hideBreadcrumbs = booleanStringCheck(
    registry['breadcrumbs']?.breadcrumbs?.[0]?.hideBreadcrumbs,
  );

  breadcrumbs = hideBreadcrumbs ? [] : breadcrumbs;

  const heroData = data.hero
    ? data.hero.constructor === Array
      ? data.hero[0]
      : data.hero
    : data;

  const heroImage = heroData && heroData.image && heroData.image[0];

  return {
    heroSearch,
    breadcrumbs,
    heroData,
    heroImage,
  };
};
